import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export enum SocialWeakCodeType {
  MERIT = 'MERIT', // 국가유공자
  D1 = 'D1', // 중증장애인
  D2 = 'D2', // 경증장애인
  HBM = 'HBM', // 한부모가족
  B = 'B', // 기초생활
  M = 'M', // 다자녀
  NONE = 'NONE', // For null case
}

export default function useVehicleInspectionReservationUtil() {
  const {t} = useInferableTranslation();

  const inspectionLabels: Record<string, string> = {
    '21': t('T40183'),
    '2b': t('T40184'),
    Ag: t('T40185'),
    Ah: t('T40186'),
    Bp: t('T40187'),
    Bq: t('T40188'),
  };

  const socialWeakLabels: Record<SocialWeakCodeType, string> = {
    [SocialWeakCodeType.MERIT]: t('T40176'),
    [SocialWeakCodeType.D1]: t('T40177'),
    [SocialWeakCodeType.D2]: t('T40178'),
    [SocialWeakCodeType.HBM]: t('T40179'),
    [SocialWeakCodeType.B]: t('T40180'),
    [SocialWeakCodeType.M]: t('T40181'),
    [SocialWeakCodeType.NONE]: t('T40182'),
  };

  return {inspectionLabels, socialWeakLabels};
}
